import { BaseService } from 'Common/BaseService';
import { Config } from 'Config';
import { DiscussionMessageModel } from 'Common/Code/DiscussionMessage/DiscussionMessageModel';
import { HttpResponseMessage } from 'aurelia-http-client';
import { ObjectHelper } from 'Code/Helpers/ObjectHelper';
import { RESTApiAdapter } from '../Adapters/RESTApiAdapter';
import { StringHelper } from 'Code/Helpers/StringHelper';
import { autoinject } from 'aurelia-framework';
import { SystemService } from 'DataAccessLayer/Services/SystemService';
import { ResultInfo } from 'Common/Code/Model/ResultInfo';
import { GuidHelper } from 'Code/Helpers/GuidHelper';
import * as replace from 'gulp-replace';

export enum GetPageModeEnum {
    Normal = 'Normal',
    OData = 'OData',
    Export = 'Export',
    Raw = 'Raw'
}
export enum VistosRecordStatusEnum {
    Unchanged = 'Unchanged',
    Changed = 'Changed',
    Deleted = 'Deleted',
    Locked = 'Locked',
    New = 'New'
}

export enum SignTypeEnum {
    None = 'None',
    EsignoSms = 'EsignoSms',
    EsignoBiometrics = 'EsignoBiometrics',
    VistosHand = 'VistosHand',
    VistosCert = 'VistosCert'
}
export enum SignParticipantType {
    None = 'None',
    BusinessUnit = 'BusinessUnit',
    Customer = 'Customer'
}

export class IdbRecord {
    uid: string;
    Id: string | number;
    RecordId: string | number;
    Name: string;
    Caption: string;
    Created: string;
    Modified: string;
    CreatedBy_FK: string;
    ModifiedBy_FK: string;
    MainProjection: string;
    DirectoryCaption: string;
    Icon: string;
    ProjectionLoc: string;
    Role__AssignedTo: string;
    DataRole__AssignedTo: string;
    Timeline: string;
    data: any;
    RecordStatus: VistosRecordStatusEnum;
    status: string;
    ApiStatus: string;
    ApiMessValidator: string;
    ApiMessWarning: string;
    ApiMessRequired: string;
    ApiResponseSave: any;
}
export class IdbSignature {
    uid: string;
    Id: string | number;
    data: any;
    signedByName: string;
    RecordStatus: VistosRecordStatusEnum;
    status: string;
}

export class IdbPicture {
    uid: number;
    Id: string | number;
    data: any;
    RecordStatus: VistosRecordStatusEnum;
    status: string;
}
export class IdbDocument {
    uid: number;
    Id: string | number;
    data: any;
    vistosData: any;
    RecordStatus: VistosRecordStatusEnum;
    status: string;
}

export class IdbDocumentPreview {
    uid: number;
    Id: string | number;
    data: any;
    RecordStatus: VistosRecordStatusEnum;
    status: string;
}

@autoinject
export class DataService extends BaseService {

    private idbRecords: any = null;
    private isOnline: boolean = true;
    private apiUrl: string = null;

    constructor(restApiAdapter: RESTApiAdapter) {
        super(restApiAdapter);
        this.isOnline = Config.IsOnline();

        this.idbRecords = new Dexie('VistosDb');
        this.idbRecords.version(1).stores({
            Records: 'uid, Id, RecordId, Name, Caption, Created, Modified, CreatedBy_FK, ModifiedBy_FK, MainProjection, DirectoryCaption, Icon, ProjectionLoc, Role__AssignedTo, DataRole__AssignedTo, Timeline, data, RecordStatus, status'
            , Signatures: 'uid, Id, data, signedByName, RecordStatus, status'
            , PicturesFull: 'uid, Id, data, RecordStatus, status'
            , DrawPicturesFull: 'uid, Id, data, RecordStatus, status'
            , PicturesPreview: 'uid, Id, data, RecordStatus, status'
            , DrawPicturesPreview: 'uid, Id, data, RecordStatus, status'
            , Documents: 'uid, Id, data, vistosData, RecordStatus, status'
            , DocumentsPreview: 'uid, Id, data, RecordStatus, status'
        });
        this.apiUrl = Config.ApiUrl();
    }

    public SetIsOnline(isOnline: boolean) {
        this.isOnline = isOnline;
    }

    private async CallApi(body: any): Promise<any> {
        let response: any = await this.restApiAdapter.Execute(body);
        let schemaVer: string = localStorage[Config.TokenName() + '_schemaVer'];
        if (response != null && ObjectHelper.IsNotNullAndUndefined(response.schema_ver) && ObjectHelper.IsNotNullAndUndefined(schemaVer) &&
            StringHelper.IsNotNullAndEmptyAndUndefined(response.schema_ver) &&
            StringHelper.IsNotNullAndEmptyAndUndefined(schemaVer) &&
            response.schema_ver != schemaVer) {
            console.log('reset cache, update schema !!');
            await SystemService.Instance.ClearCache_All();
            await SystemService.Instance.GetSchema();
            await SystemService.Instance.GetMenu();
        }

        return response;
    }

    public async OptimCallCallDial(callFromLineNumber: string, calledNumber: string) {
        let body = {};
        body['OptimCallCallDialParam'] = {
            "CallFromLineNumber": callFromLineNumber,
            "CalledNumber": calledNumber
        };

        return await this.CallApi(body);
    }

    public async OptimCallCallDisconect(callId: number) {
        let body = {};
        body['OptimCallCallDisconectParam'] = {
            "Id": callId
        };

        return await this.CallApi(body);
    }

    //public async OptimCallGetAvailableQueuesAndLines() {
    //    let body = {};
    //    body['OptimCallGetAvailableQueuesAndLinesParam'] = {};
    //
    //    return await this.CallApi(body);
    //}

    public async OptimCallAgentLogin(line: string, queues: Array<string>) {
        let body = {};
        body['OptimCallAgentLoginParam'] = {
            "Line": line,
            "Queues": ObjectHelper.ArrayIs(queues) ? queues : []
        };

        return await this.CallApi(body);
    }

    public async OptimCallAgentLogout() {
        let body = {};
        body['OptimCallAgentLogoutParam'] = {};

        return await this.CallApi(body);
    }

    public async OptimCallAgentReady() {
        let body = {};
        body['OptimCallAgentReadyParam'] = {};

        return await this.CallApi(body);
    }

    public async OptimCallAgentPause() {
        let body = {};
        body['OptimCallAgentPauseParam'] = {};

        return await this.CallApi(body);
    }

    public async OptimCallGetAgentState() {
        let body = {};
        body['OptimCallGetAgentStateParam'] = {};

        return await this.CallApi(body);
    }

    public async Create(entityName: string, data: Object): Promise<Object> {
        if (!this.isOnline) {
        }
        else {
            let body = {};
            body['CreateParam'] = {
                "EntityName": entityName,
                "Data": data
            };

            return await this.CallApi(body);
        }
    }

    public async Generate(entityName: string, data: Object): Promise<Object> {
        let body = {};
        body['GenerateParam'] = {
            "EntityName": entityName,
            "Data": data
        };

        return await this.CallApi(body);
    }

    public async PublicCreateEntityFrom(entityNameFrom: string, tokenGuid: string, configId: string): Promise<Object> {
        let body = {};
        body['PublicCreateEntityFromParam'] = {
            "enf": entityNameFrom, //EntityNameFinal
            "tg": tokenGuid, // TokenGuid
            "ci": configId, // ConfigId
        };
        return await this.CallApi(body);
    }

    public async CreateEntityFrom(actionName: string, actionTypeName: string, methodMode: string, resultType: string, entityNameTarget: string, entityNameFrom: string, entityIdFrom: number, extData: Object): Promise<Object> {
        let body = {};
        body['CreateEntityFromParam'] = {
            "ActionName": actionName,
            "ActionTypeName": actionTypeName,
            "MethodMode": methodMode,
            "ResultType": resultType,
            "EntityNameFrom": entityNameFrom,
            "EntityNameTarget": entityNameTarget,
            "EntityIdFrom": entityIdFrom,
            "ExtData": extData
        };
        return await this.CallApi(body);
    }

    public async CopyDocumentsToEmailAttachments(entityName: string, entityId: number): Promise<Object> {
        let body = {};
        body['DocumentsToEmailAttachmentsParam'] = {
            "EntityName": entityName,
            "EntityId": entityId
        };

        return await this.CallApi(body);
    }

    public async CertificateSignDocumentByDocId(entityName: string, documentId: number): Promise<Object> {
        let body = {};
        body['SignDocumentParam'] = {
            "EntityName": entityName,
            "DocumentId": documentId,
            "SigntType": SignTypeEnum.VistosCert
        };

        return await this.CallApi(body);
    }

    //1 - Esigno SMS
    //2 - Esigno Biometrika
    //3 - Vistos rucni podpis
    //4 - Vistos certifikat    
    public async SignDocument(entityName: string, entityId: number, rdlReportName: string, reportName: string, languageCode: string, isCustom: boolean
        , name: string, email: string, phone: string, directoryId: number, participantType: SignParticipantType
        , signtType: SignTypeEnum, handSignGuid: string): Promise<Object> {
        let body = {};
        body['SignDocumentParam'] = {
            "EntityName": entityName,
            "EntityId": entityId,
            "RdlReportName": rdlReportName,
            "ReportName": reportName,
            "LanguageCode": languageCode,
            "IsCustom": isCustom,

            "Name": name,
            "Email": email,
            "Phone": phone,
            "DirectoryId": directoryId,
            "ParticipantType": participantType,

            "SigntType": signtType,
            "HandSignGuid": handSignGuid
        };
        return await this.CallApi(body);
    }

    public async GetDocumentOffline(id: number): Promise<string> {
        if (ObjectHelper.ObjectIs(id) && id > 0) {
            let r1: IdbPicture = await this.idbRecords.Documents.get(id);
            if (ObjectHelper.ObjectIs(r1) && ObjectHelper.ObjectIs(r1.data)) {
                if (r1.data instanceof File) {
                    return URL.createObjectURL(r1.data);
                }
                if (r1.data instanceof Blob) {
                    return URL.createObjectURL(r1.data);
                }
            }
        }
        return null;
    }
    public async GetDocumentPreviewOffline(id: number): Promise<string> {
        if (ObjectHelper.ObjectIs(id) && id > 0) {
            let r1: IdbPicture = await this.idbRecords.DocumentsPreview.get(id);
            if (ObjectHelper.ObjectIs(r1) && ObjectHelper.ObjectIs(r1.data)) {
                if (r1.data instanceof File) {
                    return URL.createObjectURL(r1.data);
                }
                if (r1.data instanceof Blob) {
                    return URL.createObjectURL(r1.data);
                }
            }
        }
        return null;
    }
    public async GetPicturesFullOffline(id: number): Promise<string> {
        if (ObjectHelper.ObjectIs(id) && id > 0) {
            let r1: IdbPicture = await this.idbRecords.PicturesFull.get(id);
            if (ObjectHelper.ObjectIs(r1) && ObjectHelper.ObjectIs(r1.data)) {
                if (r1.data instanceof File) {
                    return URL.createObjectURL(r1.data);
                }
                if (r1.data instanceof Blob) {
                    return URL.createObjectURL(r1.data);
                }
            }
        }
        return null;
    }
    public async GetPicturesPreviewOffline(id: number): Promise<string> {
        if (ObjectHelper.ObjectIs(id) && id > 0) {
            let r1: IdbPicture = await this.idbRecords.PicturesPreview.get(id);
            if (ObjectHelper.ObjectIs(r1) && ObjectHelper.ObjectIs(r1.data)) {
                return URL.createObjectURL(r1.data);
            }
        }
        return null;
    }
    public async GetDrawPicturesFullOffline(id: number): Promise<string> {
        if (ObjectHelper.ObjectIs(id) && id > 0) {
            let r1: IdbPicture = await this.idbRecords.DrawPicturesFull.get(id);
            if (ObjectHelper.ObjectIs(r1) && ObjectHelper.ObjectIs(r1.data)) {
                if (r1.data instanceof File) {
                    return URL.createObjectURL(r1.data);
                }
                if (r1.data instanceof Blob) {
                    return URL.createObjectURL(r1.data);
                }
            }
        }
        return null;
    }
    public async GetDrawPicturesPreviewOffline(id: number): Promise<string> {
        if (ObjectHelper.ObjectIs(id) && id > 0) {
            let r1: IdbPicture = await this.idbRecords.DrawPicturesPreview.get(id);
            if (ObjectHelper.ObjectIs(r1) && ObjectHelper.ObjectIs(r1.data)) {
                return URL.createObjectURL(r1.data);
            }
        }
        return null;
    }

    public async UpdateOfflineSignature(sig: IdbSignature) {
        return await this.idbRecords.Signatures.put(sig, sig.uid);
    }

    public async GetAllOfflineSignatures(): Promise<Array<IdbSignature>> {
        return await this.idbRecords.Signatures.toArray();
    }

    public async GetSignatureOffline(uid: string): Promise<string> {
        let r1: IdbSignature = await this.idbRecords.Signatures.get(uid);
        if (ObjectHelper.ObjectIs(r1) && ObjectHelper.ObjectIs(r1.data)) {
            if (r1.data instanceof Blob) {
                return URL.createObjectURL(r1.data);
            }
            return r1.data;
        }
        return null;
    }

    public async AddSignature(data: string, signedByName: string): Promise<Object> {
        if (!this.isOnline) {
            const uid = "offline___" + GuidHelper.NewGuid();

            let r1: IdbSignature = new IdbSignature();
            r1.uid = uid;
            r1.Id = uid;
            r1.data = data;
            r1.signedByName = signedByName;
            r1.RecordStatus = VistosRecordStatusEnum.New;
            r1.status = "OK";
            await this.idbRecords.Signatures.put(r1, uid);

            let responseSave: any = {
                status: 'OK',
                data: uid
            }
            return responseSave;
        }
        else {
            let body = {};
            body['AddSignatureParam'] = {
                "Data": data,
                "SignedByName": signedByName
            };

            return await this.CallApi(body);
        }
    }

    public async MassAddToOfflineDb(entityName: string, selectedIds: Array<number>, entitySchema: any) {
        if (StringHelper.StringIs(entityName) && ObjectHelper.ArrayIs(selectedIds)) {

            for (let i1 = 0; i1 < selectedIds.length; i1++) {
                const entityId: number = selectedIds[i1];
                await this.AddToOfflineDb(entityName, entityId, entitySchema);
            }
        }
    }

    public async UpdateOfflineDbMain(r1: IdbRecord) {
        await this.idbRecords.Records.put(r1, r1.uid);
    }

    private async AddToOfflineDbMain(entityName: string, entityId: number, data: any, recordStatus: VistosRecordStatusEnum) {
        const uid: string = entityName + "___" + entityId;
        let r1: IdbRecord = new IdbRecord();
        //console.log(111, 'IdbRecord', 2);
        r1.uid = uid;
        r1.Id = entityId;
        r1.RecordId = entityId;
        r1.Name = StringHelper.StringIs(data['Name']) ? data['Name'] : data['Caption'];
        r1.Caption = data['Caption'];
        r1.Created = data['Created'];
        r1.Modified = data['Modified'];
        r1.CreatedBy_FK = data['CreatedBy_FK_Caption'];
        r1.ModifiedBy_FK = data['ModifiedBy_FK_Caption'];
        r1.MainProjection = entityName;
        if (StringHelper.StringIs(data['Account_FK_Caption']))
            r1.DirectoryCaption = data['Account_FK_Caption'];
        if (StringHelper.StringIs(data['Directory_FK_Caption']))
            r1.DirectoryCaption = data['Directory_FK_Caption'];
        if (StringHelper.StringIs(data['Customer_FK_Caption']))
            r1.DirectoryCaption = data['Customer_FK_Caption'];
        if (StringHelper.StringIs(data['Supplier_FK_Caption']))
            r1.DirectoryCaption = data['Supplier_FK_Caption'];
        r1.Icon = SystemService.Instance.GetIconByEntity(entityName);
        r1.ProjectionLoc = SystemService.Instance.GetTitleByEntity(entityName);
        r1.Role__AssignedTo = null
        r1.DataRole__AssignedTo = null
        r1.Timeline = null
        r1.data = data;
        r1.RecordStatus = recordStatus;
        r1.status = "OK";
        //console.log(111, 'IdbRecord', 3);
        await this.idbRecords.Records.put(r1, uid);
    }

    public async AddToOfflineDb(entityName: string, entityId: number, entitySchema: any) {
        let resposne1: any = await this.GetById(entityName, entityId);
        if (ObjectHelper.ObjectIs(resposne1) && ObjectHelper.ObjectIs(resposne1.data)) {
            const data1 = resposne1.data;
            await this.AddToOfflineDbMain(entityName, entityId, data1, VistosRecordStatusEnum.Unchanged);
            for (let i1 = 0; i1 < entitySchema['Columns'].length; i1++) {
                const column = entitySchema['Columns'][i1];
                switch (column.Type_FK) {
                    case 10: //	Entity
                        //case 47: //	MultiEntity
                        {
                            if (StringHelper.StringIs(column.EntityNameType_FK) && ObjectHelper.ObjectIs(data1[column.ColumnName]) && data1[column.ColumnName] > 0) {
                                let resposne2: any = await this.GetById(column.EntityNameType_FK, data1[column.ColumnName]);
                                if (ObjectHelper.ObjectIs(resposne2) && ObjectHelper.ObjectIs(resposne2.data)) {
                                    const data2 = resposne2.data;
                                    await this.AddToOfflineDbMain(column.EntityNameType_FK, data1[column.ColumnName], data2, VistosRecordStatusEnum.Locked);
                                }
                            }
                        }
                        break;
                    case 38: //	Picture
                        {
                            if (ObjectHelper.ObjectIs(data1[column.ColumnName]) && data1[column.ColumnName] > 0) {
                                const url1: string = `${this.apiUrl}/GetFullPicture/${data1[column.ColumnName]}?userToken=${JSON.parse(localStorage[Config.TokenName()] || null).Token}`;
                                fetch(url1).then(resp => resp.blob()).then(async blob => {
                                    if (ObjectHelper.ObjectIs(blob) && blob.size > 0) {
                                        const uid: number = data1[column.ColumnName];
                                        let r1: IdbPicture = new IdbPicture();
                                        r1.uid = uid;
                                        r1.Id = uid;
                                        r1.data = blob;
                                        r1.RecordStatus = VistosRecordStatusEnum.Locked;
                                        r1.status = "OK";
                                        await this.idbRecords.PicturesFull.put(r1, uid);
                                    }
                                });

                                const url2: string = `${this.apiUrl}/GetPreviewPicture/${data1[column.ColumnName]}?userToken=${JSON.parse(localStorage[Config.TokenName()] || null).Token}`;
                                fetch(url2).then(resp => resp.blob()).then(async blob => {
                                    if (ObjectHelper.ObjectIs(blob) && blob.size > 0) {
                                        const uid: number = data1[column.ColumnName];
                                        let r1: IdbPicture = new IdbPicture();
                                        r1.uid = uid;
                                        r1.Id = uid;
                                        r1.data = blob;
                                        r1.RecordStatus = VistosRecordStatusEnum.Locked;
                                        r1.status = "OK";
                                        await this.idbRecords.PicturesPreview.put(r1, uid);
                                    }
                                });

                                const url3: string = `${this.apiUrl}/GetDrawPicture/${data1[column.ColumnName]}?userToken=${JSON.parse(localStorage[Config.TokenName()] || null).Token}`;
                                fetch(url3).then(resp => resp.blob()).then(async blob => {
                                    if (ObjectHelper.ObjectIs(blob) && blob.size > 0) {
                                        const uid: number = data1[column.ColumnName];
                                        let r1: IdbPicture = new IdbPicture();
                                        r1.uid = uid;
                                        r1.Id = uid;
                                        r1.data = blob;
                                        r1.RecordStatus = VistosRecordStatusEnum.Locked;
                                        r1.status = "OK";
                                        await this.idbRecords.DrawPicturesFull.put(r1, uid);
                                    }
                                });

                                const url4: string = `${this.apiUrl}/GetPreviewDrawPicture/${data1[column.ColumnName]}?userToken=${JSON.parse(localStorage[Config.TokenName()] || null).Token}`;
                                fetch(url4).then(resp => resp.blob()).then(async blob => {
                                    if (ObjectHelper.ObjectIs(blob) && blob.size > 0) {
                                        const uid: number = data1[column.ColumnName];
                                        let r1: IdbPicture = new IdbPicture();
                                        r1.uid = uid;
                                        r1.Id = uid;
                                        r1.data = blob;
                                        r1.RecordStatus = VistosRecordStatusEnum.Locked;
                                        r1.status = "OK";
                                        await this.idbRecords.DrawPicturesPreview.put(r1, uid);
                                    }
                                });
                            }
                        }
                        break;
                    case 13: //	Signature
                        {
                            if (StringHelper.StringIs(data1[column.ColumnName])) {
                                const signImageUrl: string = `${this.apiUrl}/GetSignatureImageByGuid/${data1[column.ColumnName]}?userToken=${JSON.parse(localStorage[Config.TokenName()] || null).Token}`;
                                fetch(signImageUrl).then(resp => resp.blob()).then(async blob => {
                                    const uid: string = data1[column.ColumnName];
                                    let r1: IdbSignature = new IdbSignature();
                                    r1.uid = uid;
                                    r1.Id = uid;
                                    r1.data = blob;
                                    r1.signedByName = null;
                                    r1.RecordStatus = VistosRecordStatusEnum.Locked;
                                    r1.status = "OK";
                                    await this.idbRecords.Signatures.put(r1, uid);
                                });
                            }
                        }
                        break;
                }
            }

            if (ObjectHelper.ArrayIs(data1.Document)) {
                for (let i1 = 0; i1 < data1.Document.length; i1++) {
                    const doc1 = data1.Document[i1];
                    const docUrl: string = `${this.apiUrl}/Download/${doc1.Id}?&entityName=Document&userToken=${JSON.parse(localStorage[Config.TokenName()] || null).Token}`;
                    fetch(docUrl).then(resp => resp.blob()).then(async blob => {
                        const uid: number = doc1.Id;
                        let r1: IdbDocument = new IdbDocument();
                        r1.uid = uid;
                        r1.Id = uid;
                        r1.data = blob;
                        r1.vistosData = doc1;
                        r1.RecordStatus = VistosRecordStatusEnum.Locked;
                        r1.status = "OK";
                        await this.idbRecords.Documents.put(r1, uid);

                        if (blob.type.startsWith('image')) {
                            const docPrewUrl: string = `${this.apiUrl}/DocumentPreview/${doc1.Id}?&entityName=Document&userToken=${JSON.parse(localStorage[Config.TokenName()] || null).Token}`;
                            fetch(docPrewUrl).then(resp => resp.blob()).then(async blob => {
                                const uid: number = doc1.Id;
                                let r1: IdbDocumentPreview = new IdbDocumentPreview();
                                r1.uid = uid;
                                r1.Id = uid;
                                r1.data = blob;
                                r1.RecordStatus = VistosRecordStatusEnum.Locked;
                                r1.status = "OK";
                                await this.idbRecords.DocumentsPreview.put(r1, uid);
                            });
                        }
                    });

                }
            }
        }
    }

    public async MassRemove(entityName: string, selectedIds: Array<number>) {
        let body = {};
        body['MassRemoveParam'] = {
            "EntityName": entityName,
            "EntityIds": selectedIds
        };

        return await this.CallApi(body);
    }

    public async ClearOfflineDb() {
        await this.idbRecords.Records.clear();
        await this.idbRecords.Documents.clear();
        await this.idbRecords.DocumentsPreview.clear();
        await this.idbRecords.PicturesFull.clear();
        await this.idbRecords.PicturesPreview.clear();
        await this.idbRecords.DrawPicturesPreview.clear();
        await this.idbRecords.Signatures.clear();
    }

    public async RemoveFromOfflineDb(entityName: string, entityId: number) {
        const uid: string = entityName + "___" + entityId;
        let r1: any = await this.idbRecords.Records.delete(uid);
        console.log(777777, r1);
    }

    public async Remove(entityName: string, entityId: number, parentEntityName: string, parentEntityId: number, gridMode: string) {
        if (!this.isOnline) {

            let responseSave: any = {
                status: 'OK'
            }
            return responseSave;
        }
        else {
            let body = {};
            body['RemoveParam'] = {
                "EntityName": entityName,
                "EntityId": entityId,
                "ParentEntityName": parentEntityName,
                "ParentEntityId": parentEntityId,
                "GridMode": gridMode
            };

            return await this.CallApi(body);
        }
    }

    public async GdprDeleteData(entityName: string, entityId: number, columns: Array<string>) {
        let body = {};
        body['GdprDeleteDataParam'] = {
            "EntityName": entityName,
            "EntityId": entityId,
            "Columns": columns
        };

        return await this.CallApi(body);
    }

    public async Save(entityName: string, entityId: number, data: Object, configId: string = null, withJoinedEntities: boolean = false): Promise<Object> {
        if (!this.isOnline) {
            //console.log(111, 'IdbRecord', 1);
            const uid: string = entityName + "___" + entityId;
            let r1: IdbRecord = new IdbRecord();
            //console.log(111, 'IdbRecord', 2);
            r1.uid = uid;
            r1.Id = entityId;
            r1.RecordId = entityId;
            r1.Name = StringHelper.StringIs(data['Name']) ? data['Name'] : data['Caption'];
            r1.Caption = data['Caption'];
            r1.Created = data['Created'];
            r1.Modified = data['Modified'];
            r1.CreatedBy_FK = data['CreatedBy_FK_Caption'];
            r1.ModifiedBy_FK = data['ModifiedBy_FK_Caption'];
            r1.MainProjection = entityName;
            if (StringHelper.StringIs(data['Account_FK_Caption']))
                r1.DirectoryCaption = data['Account_FK_Caption'];
            if (StringHelper.StringIs(data['Directory_FK_Caption']))
                r1.DirectoryCaption = data['Directory_FK_Caption'];
            if (StringHelper.StringIs(data['Customer_FK_Caption']))
                r1.DirectoryCaption = data['Customer_FK_Caption'];
            if (StringHelper.StringIs(data['Supplier_FK_Caption']))
                r1.DirectoryCaption = data['Supplier_FK_Caption'];
            r1.Icon = SystemService.Instance.GetIconByEntity(entityName);
            r1.ProjectionLoc = SystemService.Instance.GetTitleByEntity(entityName);
            r1.Role__AssignedTo = null
            r1.DataRole__AssignedTo = null
            r1.Timeline = null
            r1.data = data;
            r1.RecordStatus = VistosRecordStatusEnum.Changed;
            r1.status = "OK";
            //console.log(111, 'IdbRecord', 3);
            await this.idbRecords.Records.put(r1, uid);
            //console.log(111, 'IdbRecord', 4);

            let responseSave: any = {
                status: 'OK'
            }
            return responseSave;
        }
        else {
            let body = {};
            body['SaveParam'] = {
                "EntityName": entityName,
                "EntityId": entityId,
                "Data": data,
                "ci": configId,
                "WithJoinedEntities": withJoinedEntities
            };

            return await this.CallApi(body);
        }
    }

    public async SaveByMethodMode(entityName: string, entityId: number, data: Object, methodMode: string, colNameToUpdate: Array<string>): Promise<Object> {
        if (!this.isOnline) {
        }
        else {
            let body = {};
            body['SaveParam'] = {
                "EntityName": entityName,
                "EntityId": entityId,
                "Data": data,
                "MethodMode": methodMode,
                "ColNameToUpdate": colNameToUpdate
            };

            return await this.CallApi(body);
        }
    }

    public async SetUserReactions(entityName: string, entityId: number, discussionMessageId: number, typeId: number): Promise<any> {
        const clientCookie: string = Cookies.get('ccuid');
        if (!this.isOnline) {
        }
        else {
            let body = {};
            body['SetUserReactionsParam'] = {
                "EntityName": entityName,
                "EntityId": entityId,
                "ClientCookie": clientCookie,
                "DiscussionMessageId": discussionMessageId,
                "TypeId": typeId
            };
            return await this.CallApi(body);
        }
    }

    public async SetEmailIsRead(emailId: number, read: boolean) {
        let body = {};

        body['SetEmailIsReadParam'] = {
            "EmailId": emailId,
            "IsRead": read
        };

        return await this.CallApi(body);
    }

    public async SetEmailsIsRead(emailsId: Array<number>, read: boolean) {
        let body = {};

        body['SetEmailsIsReadParam'] = {
            "EmailsId": emailsId,
            "IsRead": read
        };

        return await this.CallApi(body);
    }

    public async SetEmailFolderIsRead(folderId: number, read: boolean) {
        let body = {};

        body['SetEmailFolderIsReadParam'] = {
            "FolderId": folderId,
            "IsRead": read
        };

        return await this.CallApi(body);
    }

    public async MoveEmailsToFolder(folderId: number, emailIds: Array<number>) {
        let body = {};

        body['MoveEmailsToFolderParam'] = {
            "FolderId": folderId,
            "EmailIds": emailIds
        };

        return await this.CallApi(body);
    }

    public async SetEmailIsLinkedWithVistos(emailId: number, flagged: boolean) {
        let body = {};

        body['SetEmailIsLinkedWithVistosParam'] = {
            "EmailId": emailId,
            "IsFlagged": flagged
        };

        return await this.CallApi(body);
    }

    public async SetEmailIsFlagged(emailId: number, flagged: boolean) {
        let body = {};

        body['SetEmailIsFlaggedParam'] = {
            "EmailId": emailId,
            "IsFlagged": flagged
        };

        return await this.CallApi(body);
    }

    public async SaveAccessRights(data: Object, profileId: number): Promise<Object> {
        let body = {};
        body['SaveAccessRightsParam'] = {
            "ForProfil": profileId,
            "Data": data
        };

        return await this.CallApi(body);
    }

    public async SaveAccessRightsColumns(data: Object): Promise<Object> {
        let body = {};
        body['SaveAccessRightsColumnsParam'] = {
            "Data": data
        };

        return await this.CallApi(body);
    }

    public async SaveLocalization(data: Object): Promise<Object> {
        let body = {};
        body['SaveLocalizationParam'] = {
            "Data": data
        };

        return await this.CallApi(body);
    }

    public async GetEntityFiltered(entityName: string, filter: Object): Promise<Object> {
        if (!this.isOnline) {
        }
        else {
            let body = {};
            body['GetEntityFilteredParam'] = {
                "EntityName": entityName,
                "Filter": this.FilterHelper(filter)
            };

            return await this.CallApi(body);
        }
    }

    public async GetByIdSimple(entityName: string, entityId: number): Promise<Object> {
        if (!this.isOnline) {
            const uid: string = entityName + "___" + entityId;
            let r1: any = await this.idbRecords.Records.get(uid);
            if (ObjectHelper.ObjectIs(r1) && ObjectHelper.ObjectIs(r1.data)) {
                return r1;
            }
        }
        else {
            let body = {};
            body['GetByIdParam'] = {
                "EntityName": entityName,
                "EntityId": entityId,
                "MethodMode": "HeaderAndItemRows"
            };

            return await this.CallApi(body);
        }
    }

    public async GetById(entityName: string, entityId: number): Promise<Object> {
        console.log(22221, 'GetById', this.isOnline);
        if (!this.isOnline) {
            const uid: string = entityName + "___" + entityId;
            let r1: any = await this.idbRecords.Records.get(uid);
            if (ObjectHelper.ObjectIs(r1) && ObjectHelper.ObjectIs(r1.data)) {
                return r1;
            }
        }
        else {
            let body = {};
            body['GetByIdParam'] = {
                "EntityName": entityName,
                "EntityId": entityId,
                "MethodMode": "Full"
            };
            const r: any = await this.CallApi(body);
            return r;
        }
    }

    public async PublicGetByIdMethodMode(entityName: string, configId: string, tokenGuid: string, methodMode: string): Promise<Object> {
        let body = {};
        body['PublicGetByIdParam'] = {
            "en": entityName,
            "tg": tokenGuid,
            "ci": configId,
            "mm": methodMode
        };

        return await this.CallApi(body);
    }

    public async GetByIdMethodMode(entityName: string, entityId: number, methodMode: string, colNameToRead: Array<string> = null): Promise<Object> {
        //console.log(22222, 'GetById', this.isOnline);
        if (!this.isOnline) {
            const uid: string = entityName + "___" + entityId;
            let r1: any = await this.idbRecords.Records.get(uid);
            if (ObjectHelper.ObjectIs(r1) && ObjectHelper.ObjectIs(r1.data)) {
                return r1;
            }
        }
        else {
            let body = {};
            body['GetByIdParam'] = {
                "EntityName": entityName,
                "EntityId": entityId,
                "MethodMode": methodMode,
                "ColNameToRead": colNameToRead
            };

            return await this.CallApi(body);
        }
    }

    public async GetRsReportList(): Promise<Object> {
        let body = {};
        body['GetRsReportList'] = {
            "GetRsReportList": "ReportList"
        };

        return await this.CallApi(body);
    }

    private FilterHelper(filter: Object): Object {
        let filter1 = ObjectHelper.IsNotNullAndUndefinedAndEmpty(filter) ? JSON.parse(JSON.stringify(filter)) : {};
        let selectedBusinessUnit: number = sessionStorage['SelectedBusinessUnit']
        if (ObjectHelper.IsNotNullAndUndefinedAndEmpty(selectedBusinessUnit) && selectedBusinessUnit > 0
            && ObjectHelper.IsNullOrUndefined(filter1['BusinessUnit_FK'])
        ) {
            filter1['BusinessUnit_FK'] = selectedBusinessUnit;
        }
        return filter1;
    }

    public async GetGanttData(entityName: string, filter: Object): Promise<Object> {
        let body = {}
        body['GetGanttDataParam'] = {
            "EntityName": entityName,
            "Filter": this.FilterHelper(filter)
        };

        return await this.CallApi(body);
    }

    public async SaveGanttData(entityName: string, data: Array<any>, links: Array<any>, itemsToDelete: Array<string>): Promise<Object> {
        let body = {}
        body['SaveGanttDataParam'] = {
            "EntityName": entityName,
            "Data": data,
            "Links": links,
            "ItemsToDelete": itemsToDelete
        };

        return await this.CallApi(body);
    }

    public async GetTrackChangesByEntity(entityName: string, entityId: number, filter: Object): Promise<Object> {
        let body = {}
        body['GetTrackChangesByEntityParam'] = {
            "EntityName": entityName,
            "EntityId": entityId,
            "Filter": this.FilterHelper(filter)
        };

        return await this.CallApi(body);
    }

    public async GetFilteredSorted(entityName: string, rowIndex: number, pageSize: number, sortColumn: Array<Object>
        , filter: Object, filterByRecord: object, parentEntityName: string, parentEntityId: number, projectionRelationName: string
        , draw: number, columns: Array<Object>, gridMode: string, withStats: boolean, getPageMode: GetPageModeEnum): Promise<Object> {
        if (entityName == 'EntityActivity' && parentEntityName == 'OfflineManager') {
            let response: any = {
                "status": "OK",
                "message": "",
                "data": {
                    "draw": draw,
                    "recordsTotal": 53,
                    "recordsFiltered": 53
                }
            };
            let records: Array<IdbRecord> = await this.idbRecords.Records.toArray();
            records = records.filter((item) => item.RecordStatus == VistosRecordStatusEnum.Changed || item.RecordStatus == VistosRecordStatusEnum.New || item.RecordStatus == VistosRecordStatusEnum.Unchanged);
            response.data.data = records;
            response.data.recordsTotal = response.data.data.length;
            response.data.recordsFiltered = response.data.data.length;
            return response;
        }
        if (!this.isOnline) {
        }
        else {
            let body = {}
            body['GetPageParam'] = {
                "EntityName": entityName,
                "Draw": draw,
                "Start": ObjectHelper.IsNotNullAndUndefined(rowIndex) ? rowIndex : 0,
                "Length": ObjectHelper.IsNotNullAndUndefined(pageSize) ? pageSize : 10,
                "SortOrder": sortColumn,
                "Filter": this.FilterHelper(filter),
                "FilterByRecord": filterByRecord,
                "ParentEntityName": parentEntityName,
                "ParentEntityId": parentEntityId,
                "ProjectionRelationName": projectionRelationName,
                "Columns": columns,
                "GridMode": gridMode,
                "WithStats": withStats,
                "GetPageMode": getPageMode
            };

            let resposne: any = await this.CallApi(body);
            if (ObjectHelper.IsNotNullAndUndefined(resposne['status']) && resposne['status'] == 'OK' && resposne.hasOwnProperty('data')
                && ObjectHelper.ArrayIs(resposne['data'].data)) {
                const schema = await SystemService.Instance.GetSchemaByEntity(entityName);
                let schemaColumnenumtypes: Object = {};
                if (ObjectHelper.ObjectIs(schema) && ObjectHelper.ArrayIs(schema['Columns']))
                    for (let i1 = 0; i1 < schema['Columns'].length; i1++) {
                        switch (schema['Columns'][i1].Type_FK) {
                            case 8:  //	Enumeration
                            case 21:  //	EntityEnumeration
                            case 40:  //	ProcessBar
                                {
                                    if (StringHelper.StringIs(schema['Columns'][i1]['EnumType'])) {
                                        schemaColumnenumtypes[schema['Columns'][i1]['ColumnName']] = schema['Columns'][i1]['EnumType'];
                                    }
                                }
                                break;
                        }
                    }

                for (let i1 = 0; i1 < resposne['data'].data.length; i1++) {
                    for (var p in resposne['data'].data[i1]) {
                        if (p.endsWith('_FK') && ObjectHelper.ObjectIs(resposne['data'].data[i1][p])) {
                            if (ObjectHelper.ObjectIs(schemaColumnenumtypes) && ObjectHelper.ObjectIs(schemaColumnenumtypes[p])
                                && StringHelper.StringIs(schemaColumnenumtypes[p])) {
                                resposne['data'].data[i1][p + '_Description'] =
                                    await SystemService.Instance.GetEnumerationItemDescriptionById(schemaColumnenumtypes[p], resposne['data'].data[i1][p]);
                            }
                        }
                    }
                }
            }
            //console.log(1111, resposne);
            return resposne;
        }
    }

    public async GetGridCount(entityName: string, parentEntityName: string, parentEntityId: number, projectionRelationName: string): Promise<Object> {
        if (!StringHelper.IsNullOrEmptyOrUndefined(entityName) && !StringHelper.IsNullOrEmptyOrUndefined(parentEntityName)
            && ObjectHelper.IsNotNullAndUndefined(parentEntityId) && parentEntityId > 0) {
            if (!this.isOnline) {
            }
            else {
                let body = {}
                body['GetGridCountParam'] = {
                    "EntityName": entityName,
                    "ParentEntityName": parentEntityName,
                    "ParentEntityId": parentEntityId,
                    "ProjectionRelationName": projectionRelationName
                };
                return await this.CallApi(body);
            }

        };
        return 0;
    }

    public async GetChartData(chartDefinition: Object, filter: Object, entityName: string, sortFieldName: string = null, sortDesc: boolean = false): Promise<Object> {
        let body = {}
        body['ChartDataParam'] = {
            "ChartDefinition": chartDefinition,
            "Filter": filter,
            "EntityName": entityName,
            "SortFieldName": sortFieldName,
            "SortDesc": sortDesc
        };
        return await this.CallApi(body);
    }

    public async AresGetInfoByRegNumber(RegNumber: string, CountryCode: string): Promise<Object> {
        let body = {}
        body['AresGetInfoByRegNumberParam'] = {
            "RegNumber": RegNumber,
            "CountryCode": CountryCode
        };
        return await this.CallApi(body);
    }

    public async AresSearch(Search: string, CountryCode: string): Promise<Object> {
        let body = {}
        body['AresSearchParam'] = {
            "Search": Search,
            "CountryCode": CountryCode
        };

        return await this.CallApi(body);
    }

    public async MerkGetInfoByRegNumber(RegNumber: string, CountryCode: string, Advanced: boolean): Promise<Object> {
        let body = {}
        body['MerkGetInfoByRegNumberParam'] = {
            "RegNumber": RegNumber,
            "CountryCode": CountryCode,
            "Advanced": Advanced
        };
        return await this.restApiAdapter.Execute(body);
    }

    public async MerkSearch(RegNumber: string, Name: string, Email: string, CountryCode: string): Promise<Object> {
        let body = {}
        body['MerkSearchParam'] = {
            "RegNumber": RegNumber,
            "Name": Name,
            "Email": Email,
            "CountryCode": CountryCode
        };

        return await this.restApiAdapter.Execute(body);
    }

    public async SearchRuianAddress(Text: string, ResultCount: number, SearchIndex: number): Promise<Object> {
        let body = {}
        body['SearchRuianAddressParam'] = {
            "Text": Text,
            "ResultCount": ResultCount
        };

        let result: any = await this.CallApi(body);
        result.SearchIndex = SearchIndex;
        return result;
    }

    public async GetGridIds(entityName: string, filter: Object, parentEntityName: string, parentEntityId: number
        , projectionRelationName: string, ignoreVisibleOnFilter: boolean, gridMode: string): Promise<Object> {
        if (!this.isOnline) {
        }
        else {
            let body = {}
            body['GetGridIdsParam'] = {
                "EntityName": entityName,
                "Filter": this.FilterHelper(filter),
                "ParentEntityName": parentEntityName,
                "ParentEntityId": parentEntityId,
                "ProjectionRelationName": projectionRelationName,
                "IgnoreVisibleOnFilter": ignoreVisibleOnFilter,
                "GridMode": gridMode
            };

            return await this.CallApi(body);
        }
    }

    public async GetAutocomplete(entityName: string, searchText: string, filter: Object, filterByRecord: Object): Promise<Object> {
        let body = {}
        body['GetAutocompleteParam'] = {
            "EntityName": entityName,
            "SearchText": searchText,
            "Filter": this.FilterHelper(filter),
            "FilterByRecord": filterByRecord,
        };

        return await this.CallApi(body);
    }

    public async GetCategoriesByProjectionName(projectionName: string): Promise<Object> {
        let body = {}
        body['GetCategoriesByProjectionNameParam'] = {
            "ProjectionName": projectionName
        };

        return await this.CallApi(body);
    }

    public async FullTextSearch(Text: string, IncludeDiscussionMessage: boolean, IncludeEmails: boolean, DbObjectIdArrayJson: Object, ColumName: string, Direction: string): Promise<Object> {
        let body = {}
        body['FullTextSearchParam'] = {
            "Text": Text,
            "IncludeDiscussionMessage": IncludeDiscussionMessage,
            "IncludeEmails": IncludeEmails,
            "DbObjectIdArrayJson": DbObjectIdArrayJson,
            "ColumName": ColumName,
            "Direction": Direction
        };

        return await this.CallApi(body);
    }

    public async GetCalendarData(startDate: any, endDate: any, filter: Object): Promise<Object> {
        let body = {}
        body['GetCalendarDataParam'] = {
            "StartDate": startDate,
            "EndDate": endDate,
            "Filter": this.FilterHelper(filter)
        };

        return await this.CallApi(body);
    }

    public async GetCalendarItems(startDate: any, endDate: any, filter: Object): Promise<Object> {
        let body = {}
        body['GetCalendarItemsParam'] = {
            "StartDate": startDate,
            "EndDate": endDate,
            "Filter": this.FilterHelper(filter)
        };

        return await this.CallApi(body);
    }

    public async GetSpData(spName: string, spParameters: Object): Promise<Object> {
        let body = {}
        body['GetSpDataParam'] = {
            "SpName": spName,
            "SpParameters": spParameters
        };

        return await this.CallApi(body);
    }

    public async UpdateCalendarData(entityId: number, entityName: string, startDate: any, endDate: any): Promise<Object> {
        let body = {}
        body['UpdateCalendarDataParam'] = {
            "EntityId": entityId,
            "EntityName": entityName,
            "StartDate": startDate,
            "EndDate": endDate
        };

        return await this.CallApi(body);
    }

    public async CallCustomMethod(methodName: string, entityName: string, entityId: number, data: Object) {
        let body = {}
        body['CallCustomMethodParam'] = {
            "MethodName": methodName,
            "EntityName": entityName,
            "EntityId": entityId,
            "Data": JSON.parse(JSON.stringify(data))
        };

        return await this.CallApi(body);
    }

    public async MassAddRelations(selectedIds: Array<number>, destinationEntityName: string, destinationRelationFieldName: string, destinationParentFieldName: string, modalIds: Array<number>) {
        let body = {}
        body['MassAddRelationsParam'] = {
            "SelectedIds": selectedIds,
            "DestinationEntityName": destinationEntityName,
            "DestinationRelationFieldName": destinationRelationFieldName,
            "DestinationParentFieldName": destinationParentFieldName,
            "ModalIds": modalIds
        };

        return await this.CallApi(body);
    }

    public async MassParticipantsAdd(entityName: string, entityIds: Array<number>, roleId: number, userIds: Array<number>) {
        let body = {}
        body['MassParticipantsAddParam'] = {
            "EntityName": entityName,
            "EntityIds": entityIds,
            "UserIds": userIds,
            "RoleId": roleId
        };

        return await this.CallApi(body);
    }

    public async MassParticipantsRemove(entityName: string, entityIds: Array<number>, roleId: number, userIds: Array<number>) {
        let body = {}
        body['MassParticipantsRemoveParam'] = {
            "EntityName": entityName,
            "EntityIds": entityIds,
            "UserIds": userIds,
            "RoleId": roleId
        };

        return await this.CallApi(body);
    }

    public async MarkTrackChangesAsRead(entityIds: Array<number>) {
        let body = {}
        body['MarkTrackChangesAsReadParam'] = {
            "TrackChangesIds": entityIds
        };

        return await this.CallApi(body);
    }

    public async MarkTrackChangesAsUnread(entityIds: Array<number>) {
        let body = {}
        body['MarkTrackChangesAsUnreadParam'] = {
            "TrackChangesIds": entityIds
        };

        return await this.CallApi(body);
    }

    public async MassActionGrid(entityNameFrom: string, entityNameTo: string, actionName: string, entityIds: Array<number>, value: any, grouped: boolean, defaultValues: Object, plugInMethodName: string) {
        let body = {}
        body['MassActionGridParam'] = {
            "EntityNameFrom": entityNameFrom,
            "EntityNameTo": entityNameTo,
            "ActionName": actionName,
            "EntityIds": entityIds,
            "Value": value,
            "Grouped": grouped,
            "DefaultValues": defaultValues,
            "PlugInMethodName": plugInMethodName
        };

        return await this.CallApi(body);
    }

    public async MassActionUpdate(entityName: string, entityIds: Array<number>, data: Object, mode: string) {
        let body = {}
        body['MassActionUpdate' + mode + 'Param'] = {
            "EntityName": entityName,
            "EntityId": entityIds,
            "Data": data
        };

        return await this.CallApi(body);
    }

    public async AddExistingManyToMany(entityName: string, parentEntityName: string, parentEntityId: number, entityId: Array<number>) {
        let body = {}
        body['AddExistingManyToManyParam'] = {
            "EntityName": entityName,
            "ParentEntityName": parentEntityName,
            "ParentEntityId": parentEntityId,
            "EntityId": entityId
        };

        return await this.CallApi(body);
    }

    public async GetSummaryDataRowSelected(entityName: string, rowsSelected: Array<number>, columns: Array<Object>, parentEntityName: string, parentEntityId: number, projectionRelationName: string, gridMode: string): Promise<Object> {
        let body = {}

        function isContain(value) {
            return columns.map(function (v) { return v['ColumnName']; }).indexOf(value.ColumnName) >= 0
        };

        body['GetSummaryParam'] = {
            "EntityName": entityName,
            "Filter": {},
            "FilterByRecord": {},
            "RowsSelected": rowsSelected,
            "Columns": columns,
            "ParentEntityName": parentEntityName,
            "ParentEntityId": parentEntityId,
            "ProjectionRelationName": projectionRelationName,
            "GridMode": gridMode
        }

        return await this.CallApi(body);
    }

    public async GetSummaryDataFiltered(entityName: string, filter: Object, filterByRecord: Object, columns: Array<Object>
        , parentEntityName: string, parentEntityId: number, projectionRelationName: string, gridMode: string): Promise<Object> {
        let body = {}

        function isContain(value) {
            return columns.map(function (v) { return v['ColumnName']; }).indexOf(value.ColumnName) >= 0
        };

        body['GetSummaryParam'] = {
            "EntityName": entityName,
            "Filter": this.FilterHelper(filter),
            "FilterByRecord": filterByRecord,
            "Columns": columns,
            "ParentEntityName": parentEntityName,
            "ParentEntityId": parentEntityId,
            "ProjectionRelationName": projectionRelationName,
            "GridMode": gridMode
        }

        return await this.CallApi(body);
    }

    public async ExportGrid(entityName: string, exportType: string, filter: Object, filterByRecord: Object, columns: Array<Object>, sortColumn: Array<Object>, schema: Object, parentEntityName: string, parentEntityId: number, projectionRelationName: string, gridMode: string) {
        let body = {}
        let schemaColumn: Array<Object> = schema['Columns'];

        function isContain(value) {
            return columns.map(function (v) { return v['ColumnName']; }).indexOf(value.ColumnName) >= 0
        };

        body['GetExportParam'] = {
            "EntityName": entityName,
            "SortOrder": sortColumn,
            "Filter": this.FilterHelper(filter),
            "FilterByRecord": filterByRecord,
            "Columns": columns,
            "ExportType": exportType,
            "Schema": schemaColumn.filter(isContain),
            "ParentEntityName": parentEntityName,
            "ParentEntityId": parentEntityId,
            "ProjectionRelationName": projectionRelationName,
            "GridMode": gridMode
        }
        return await this.restApiAdapter.GridExport(body);
    }

    public async IsdocExport(entityName: string, selectedIds: Array<number>): Promise<HttpResponseMessage> {
        let body = {}

        body['GetIsdocExportParam'] = {
            "EntityName": entityName,
            "EntityIds": selectedIds
        }
        return await this.restApiAdapter.GridExport(body);
    }

    public async PohodaExport(entityName: string, selectedIds: Array<number>) {
        let body = {}

        body['GetPohodaExportParam'] = {
            "EntityName": entityName,
            "EntityIds": selectedIds
        }
        return await this.restApiAdapter.GridExport(body);
    }

    public async MrpExport(entityName: string, selectedIds: Array<number>) {
        let body = {}

        body['GetMrpExportParam'] = {
            "EntityName": entityName,
            "EntityIds": selectedIds
        }
        return await this.restApiAdapter.GridExport(body);
    }

    public async XmlSap1Export(entityName: string, selectedIds: Array<number>) {
        let body = {}

        body['GetXmlSap1ExportParam'] = {
            "EntityName": entityName,
            "EntityIds": selectedIds
        }
        return await this.restApiAdapter.GridExport(body);
    }

    public async VivaPayment(entityName: string, recordId: number) {
        let body = {}

        body['CreateVivaPaymentParam'] = {
            "EntityName": entityName,
            "RecordId": recordId
        }
        return await this.restApiAdapter.GridExport(body);
    }

    public async ImportDataFileUpload(formData: FormData, entityName: string, importMethod: string): Promise<HttpResponseMessage> {
        let resp: HttpResponseMessage = await this.restApiAdapter.ExecuteWithouContentProcessingWithoutTimeout("ImportFileUpload", formData, "?entityName=" + entityName + "&importMethod=" + importMethod + "&userToken=" + JSON.parse(localStorage[Config.TokenName()] || null).Token);
        return resp;
    }
    public async ImportISDOCFileUpload(formData: FormData, entityName: string): Promise<HttpResponseMessage> {
        let resp: HttpResponseMessage = await this.restApiAdapter.ExecuteWithouContentProcessingWithoutTimeout("ImportFileISDOCUpload", formData, "?entityName=" + entityName + "&userToken=" + JSON.parse(localStorage[Config.TokenName()] || null).Token);
        return resp;
    }

    private async ReturnResponse(response): Promise<Object> {
        if (ObjectHelper.IsNotNullAndUndefined(response) && response.hasOwnProperty('statusCode') && response['statusCode'] == '200'
            && response.hasOwnProperty('responseType') && response['responseType'] == 'json') {
            return JSON.parse(response.response);
        }
        return null;
    }

    public async DocumentOfficeEditGenerateToken(id: number) {
        let body = {}
        body['DocumentOfficeEditGenerateTokenParam'] = {
            "Id": id,
        };

        return await this.CallApi(body);
    }

    public async RotateImage(docId: number, rotateFlipType: string): Promise<Object> {
        return await this.ReturnResponse(await this.restApiAdapter.ExecuteWithouContentProcessing("RotateImage", null, "?id=" + docId + "&rotateFlipType=" + rotateFlipType));
    }

    public GetFileExtension(fileName): string {
        let lastDotIndex = fileName.lastIndexOf('.');

        if (lastDotIndex === -1 || lastDotIndex === 0) {
            return '';
        }

        return fileName.slice(lastDotIndex + 1);
    }

    public GetIconByFileName(fileName: string): string {
        let icon: string = "far fa-file";
        switch (this.GetFileExtension(fileName).toLowerCase()) {
            case "zip":
            case "rar":
            case "tar":
            case "7z":
                {
                    icon = "far fa-file-archive";
                    break;
                }
            case "wav":
            case "mp3":
            case "aac":
            case "weba":
                {
                    icon = "far fa-file-audio";
                    break;
                }
            case "cs":
                {
                    icon = "far fa-file-code";
                    break;
                }
            case "ods":
            case "xls":
            case "xlsx":
            case "csv":
                {
                    icon = "far fa-file-excel";
                    break;
                }
            case "bmp":
            case "png":
            case "jpg":
            case "jpeg":
            case "gif":
            case "webp":
                {
                    icon = "far fa-file-image";
                    break;
                }
            case "pdf":
                {
                    icon = "far fa-file-pdf";
                    break;
                }
            case "ppt":
            case "pptx":
            case "odp":
                {
                    icon = "far fa-file-powerpoint";
                    break;
                }
            case "txt":
            case "text":
                {
                    icon = "far fa-file";
                    break;
                }
            case "avi":
            case "mkv":
            case "mov":
            case "mpeg":
            case "webm":
                {
                    icon = "far fa-file-video";
                    break;
                }
            case "doc":
            case "docx":
            case "odt":
            case "rtf":
                {
                    icon = "far fa-file-word";
                    break;
                }
        }
        return icon;
    }

    public async GetAllOfflineDocuments(): Promise<Array<IdbDocument>> {
        return await this.idbRecords.Documents.toArray();
    }

    public async UpdateOfflineDocument(doc: IdbDocument) {
        return await this.idbRecords.Documents.put(doc, doc.uid);
    }

    public async FilesUpload(formData: FormData, type: string, isPublic: boolean, businessUnitId: number, discussionMessageId: number
        , parentEntityName: string, parentEntityId: number, documentsCount: number): Promise<Object> {
        if (!this.isOnline) {
            let result: Array<any> = [];
            let queueOrder = documentsCount;
            let uid: string = null;
            let record: IdbRecord = null;
            //console.log(33332, parentEntityName, parentEntityId);
            if (StringHelper.StringIs(parentEntityName)) {
                uid = parentEntityName + "___" + parentEntityId;
                record = await this.idbRecords.Records.get(uid);
            }

            for (var pair of formData.entries()) {
                console.log(33331, pair[0], pair[1]);
                queueOrder = queueOrder + 1;
                const file: File = formData.get(pair[0]) as File;
                const uid: number = file.lastModified;

                let doc1: any = {
                    "Deleted": false,
                    "CreatedBy_FK": 2,//
                    "CreatedBy_FK_Caption": "tester",//
                    "Created": moment().format('YYYY-MM-DD[T]HH:mm:ss'),
                    "Modified": moment().format('YYYY-MM-DD[T]HH:mm:ss'),
                    "Id": uid,
                    "Subject": file.name,
                    "CaptionSort": file.name,
                    "CaptionDisplay": file.name,
                    "Icon": this.GetIconByFileName(file.name),
                    "ContentType": file.type,
                    "AttachmentCount": 1,
                    "IsPublic": isPublic,
                    "Type_FK": null,//
                    "Type_FK_Caption": type,
                    "Type_FK_Description": type,
                    "DiscussionMessage_FK": discussionMessageId,
                    "AddAsEmailAttachment": false,
                    "UniqueGuid": GuidHelper.NewGuid(),
                    "ModifiedBy_FK_Caption": null,
                    "SignatureUniqueGuid": null,
                    "SignatureSignedByName": null,
                    "CanBeSignedAsLessor": false,
                    "IsSignedAsLessor": false,
                    "CanBeSignedAsRenter": false,
                    "IsSignedAsRenter": false,
                    "Message": null,
                    "QueueOrder": queueOrder,
                    "BusinessUnitId": businessUnitId
                };
                result.push(doc1);

                if (ObjectHelper.ObjectIs(record) && ObjectHelper.ObjectIs(record.data)) {
                    if (ObjectHelper.IsNullOrUndefined(record.data.Document)) {
                        record.data.Document = [];
                    }
                    record.data.Document.push(doc1);
                }

                //console.log(33332, record);
                {
                    let r1: IdbDocument = new IdbDocument();
                    r1.uid = uid;
                    r1.Id = uid;
                    r1.data = file;
                    r1.vistosData = doc1;
                    r1.RecordStatus = VistosRecordStatusEnum.New;
                    r1.status = "OK";
                    await this.idbRecords.Documents.put(r1, uid);
                }

                {
                    let r1: IdbDocumentPreview = new IdbDocumentPreview();
                    r1.uid = uid;
                    r1.Id = uid;
                    r1.data = file;
                    r1.RecordStatus = VistosRecordStatusEnum.New;
                    r1.status = "OK";
                    await this.idbRecords.DocumentsPreview.put(r1, uid);
                }
            }
            if (ObjectHelper.ObjectIs(record) && ObjectHelper.ObjectIs(record.data) && StringHelper.StringIs(uid)) {
                record.RecordStatus = VistosRecordStatusEnum.Changed;
                await this.idbRecords.Records.put(record, uid);
            }
            //console.log(33333, result);
            return ({ response: JSON.stringify(result) });
        }
        else {

            return await this.restApiAdapter.ExecuteWithouContentProcessing("Upload", formData, "?type=" + type + "&businessUnitId=" + businessUnitId + "&discussionMessageId=" + discussionMessageId + "&isPublic=" + isPublic + "&userToken=" + JSON.parse(localStorage[Config.TokenName()] || null).Token);
        }
    }

    public async GetAllOfflinePictures(): Promise<Array<IdbPicture>> {
        return await this.idbRecords.PicturesFull.toArray();
    }

    public async UpdateOfflinePicture(pic: IdbPicture) {
        return await this.idbRecords.PicturesFull.put(pic, pic.uid);
    }

    public async ClonePicture(id: number): Promise<number> {
        let body = {};
        body['ClonePictureParam'] = {
            "EntityId": id
        };

        let response: any = await this.CallApi(body);
        if (ObjectHelper.ObjectIs(response) && response.status == "OK" && ObjectHelper.ObjectIs(response.data) && ObjectHelper.ObjectIs(response.data.RecordId)) {
            return response.data.RecordId;
        }
        return 0;
    }

    public async UpdatePicture(formData: FormData, id: number): Promise<boolean> {
        const response = await this.restApiAdapter.ExecuteWithouContentProcessing("UpdatePicture", formData, "?id=" + id + "&userToken=" + JSON.parse(localStorage[Config.TokenName()] || null).Token);
        if (ObjectHelper.ObjectIs(response) && ObjectHelper.ObjectIs(response['response'])) {
            return response['response'];
        }
    }

    public async UploadPicture(formData: FormData, fileName: string): Promise<number> {
        if (!this.isOnline) {
            const file: File = formData.get(fileName) as File;
            const uid: number = file.lastModified;
            let r1: IdbPicture = new IdbPicture();
            r1.uid = uid;
            r1.Id = uid;
            r1.data = file;
            r1.RecordStatus = VistosRecordStatusEnum.New;
            r1.status = "OK";
            await this.idbRecords.PicturesFull.put(r1, uid);

            let r2: IdbPicture = new IdbPicture();
            r2.uid = uid;
            r2.Id = uid;
            r2.data = file;
            r2.RecordStatus = VistosRecordStatusEnum.New;
            r2.status = "OK";
            await this.idbRecords.PicturesPreview.put(r2, uid);

            return uid;
        }
        else {
            const response = await this.restApiAdapter.ExecuteWithouContentProcessing("UploadPicture", formData, "?userToken=" + JSON.parse(localStorage[Config.TokenName()] || null).Token);
            if (ObjectHelper.ObjectIs(response) && ObjectHelper.ObjectIs(response['response'])) {
                return JSON.parse(JSON.stringify(response['response'])) * 1;
            }
        }
        return null;
    }

    public async GetAllOfflineDrawPictures(): Promise<Array<IdbPicture>> {
        return await this.idbRecords.DrawPicturesFull.toArray();
    }

    public async UploadDrawPicture(formData: FormData, picId: number): Promise<boolean> {
        if (!this.isOnline) {
            const file: File = formData.get('image.jpg') as File;
            const uid: number = picId;
            let r1: IdbPicture = new IdbPicture();
            r1.uid = uid;
            r1.Id = uid;
            r1.data = file;
            r1.RecordStatus = VistosRecordStatusEnum.New;
            r1.status = "OK";
            await this.idbRecords.DrawPicturesFull.put(r1, uid);

            let r2: IdbPicture = new IdbPicture();
            r2.uid = uid;
            r2.Id = uid;
            r2.data = file;
            r2.RecordStatus = VistosRecordStatusEnum.New;
            r2.status = "OK";
            await this.idbRecords.DrawPicturesPreview.put(r2, uid);

            return true;
        }
        else {
            const response = await this.restApiAdapter.ExecuteWithouContentProcessing("UploadDrawPicture", formData, "?id=" + picId + "&userToken=" + JSON.parse(localStorage[Config.TokenName()] || null).Token);
            if (ObjectHelper.ObjectIs(response) && ObjectHelper.ObjectIs(response['response'])) {
                return true;
            }
        }
        return false;
    }

    public async ClearDrawPicture(picId: number): Promise<HttpResponseMessage> {
        if (!this.isOnline) {
            const uid: number = picId;
            await this.idbRecords.DrawPicturesFull.delete(uid);
            await this.idbRecords.DrawPicturesPreview.delete(uid);
        }
        else {
            return await this.restApiAdapter.ExecuteWithouContent("ClearDrawPicture", "?id=" + picId + "&userToken=" + JSON.parse(localStorage[Config.TokenName()] || null).Token);
        }
    }

    public async EmailAttachmentUpload(formData: FormData) {
        return await this.restApiAdapter.ExecuteWithouContentProcessing("AddEmailAttachment", formData, "?userToken=" + JSON.parse(localStorage[Config.TokenName()] || null).Token);
    }

    public async UserAvatarUpload(formData: FormData) {
        return await this.restApiAdapter.ExecuteWithouContentProcessing("ThumbnailAvatarUploadImage", formData, "?userToken=" + JSON.parse(localStorage[Config.TokenName()] || null).Token);
    }

    public UploadImport(formData: FormData, entityName: string): Promise<HttpResponseMessage> {
        return this.restApiAdapter.ExecuteWithouContentProcessing("UploadImport", formData, "?entityName=" + entityName + "&userToken=" + JSON.parse(localStorage[Config.TokenName()] || null).Token);
    }

    public async GetAccessRightsByProfile(profileId: number, projectionFilterName: string): Promise<Object> {

        let body = {};
        body['GetProjectionAccessRightsParam'] = {
            "Filter": {
                "profileId": profileId,
                "projectionFilterName": projectionFilterName
            }
        };
        let response = await this.CallApi(body);

        if (ObjectHelper.IsNotNullAndUndefined(response) && response.hasOwnProperty('data')) {
            let data = response['data'];

            // return data 
            return data;
        }
    }

    public async GetAccessRightsColumnByProjection(projectionId: number, columnFilterName: string): Promise<Object> {

        let body = {};
        body['GetAccessRightsColumnByProjectionParam'] = {
            "Filter": {
                "ProjectionId": projectionId,
                "ColumnFilterName": columnFilterName
            }
        };
        let response = await this.CallApi(body);

        if (ObjectHelper.IsNotNullAndUndefined(response) && response.hasOwnProperty('data')) {
            let data = response['data'];

            // return data 
            return data;
        }
    }

    public async GetDiscussionByEntity(entityName: string, entityId: number,
        Type_FK: boolean, Priority_FK: Array<number>, Responsible_FK: Array<number>, Status_FK: boolean
    ): Promise<Array<DiscussionMessageModel>> {
        if (!this.isOnline) {
        }
        else {
            let body = {};
            body['GetDiscussionByEntitParam'] = {
                "ProjectionName": entityName,
                "RecordId": entityId,
                "Type_FK": Type_FK,
                "Priority_FK": Priority_FK,
                "Responsible_FK": Responsible_FK,
                "Status_FK": Status_FK
            };
            let response = await this.CallApi(body);
            if (ObjectHelper.IsNotNullAndUndefined(response) && response.hasOwnProperty('data')) {
                let data = response['data'];

                return data;
            }
        }

        return null;
    }

    public async SaveDiscussionMessage(entityId: number, entityName: string, replyMessage: DiscussionMessageModel
        , message: DiscussionMessageModel, path: string, isPublic: boolean, externalChat: boolean
        , isExternal: boolean): Promise<ResultInfo> {
        let mess: DiscussionMessageModel = JSON.parse(JSON.stringify(message));
        let replyMess: DiscussionMessageModel = JSON.parse(JSON.stringify(replyMessage));
        let body = {};
        body['SaveDiscussionMessageParam'] = {
            "Message": mess,
            "RecordId": entityId,
            "ProjectionName": entityName,
            "HierarchyId": path,
            "IsPublic": isPublic,
            "ExternalChat": externalChat,
            "IsExternal": isExternal
        };

        if (ObjectHelper.ObjectIs(replyMess) && replyMess.Id > 0) {
            body['SaveDiscussionMessageParam']["ReplyMessageId"] = replyMess.Id;
        }

        let response: any = await this.CallApi(body);
        //console.warn(response);
        return response.data;
    }

    public async PublicSaveDiscussionMessage(configId: string, tokenGuid: string, entityName: string, message: DiscussionMessageModel): Promise<ResultInfo> {
        let body = {};
        body['PublicSaveDiscussionMessageParam'] = {
            "Message": message,
            "tg": tokenGuid,
            "ci": configId,
            "en": entityName
        };

        let response: any = await this.CallApi(body);
        //console.warn(response);
        return response.data;
    }

    public async UpdateDiscussionMessageColumn(entityName: string, recordId: number, messId: number, columnName: string, value: any): Promise<boolean> {

        let body = {};
        body['UpdateDiscussionMessageColumnParam'] = {
            "ProjectionName": entityName,
            "RecordId": recordId,
            "DiscussionMessageId": messId,
            "ColumnName": columnName,
            "Value": value
        };

        let response = await this.CallApi(body);
        //console.warn(response);
        if (ObjectHelper.IsNotNullAndUndefined(response) && response.hasOwnProperty('status')) {
            if (response['status'] == 'OK') {
                return true;
            }
        }

        return false;
    }

    public async PublicRecordEditing(configId: string, tokenGuid: string, entityName: string): Promise<Object> {
        let body = {};
        body['PublicRecordEditingParam'] = {
            "tg": tokenGuid,
            "ci": configId,
            "en": entityName
        };

        return await this.CallApi(body);
    }

    public async RestartAPIParam() {
        let body = {}
        body['RestartAPIParam'] = {
        };

        return await this.CallApi(body);
    }

    public async CleanCacheParam() {
        let body = {}
        body['CleanCacheParam'] = {
        };

        return await this.CallApi(body);
    }

    public async GetGoogleAuthenticatorQrCode() {
        let body = {}
        body['GetGoogleAuthenticatorQrCodeParam'] = {
        };

        return await this.CallApi(body);
    }

    public async ValidateGoogleAuthenticatorCode(userAuthCode: string) {
        let body = {}
        body['ValidateGoogleAuthenticatorCodeParam'] = {
            "Code": userAuthCode
        };

        return await this.CallApi(body);
    }

    public async GetLocalizationByProjection(projectionId: number, keyFilterName: string, columnOnly: boolean): Promise<Object> {

        let body = {};
        body['GetLocalizationParam'] = {
            "Filter": {
                "ProjectionId": projectionId,
                "KeyFilterName": keyFilterName,
                "ColumnOnly": columnOnly
            }
        };
        let response = await this.CallApi(body);

        if (ObjectHelper.IsNotNullAndUndefined(response) && response.hasOwnProperty('data')) {
            let data = response['data'];

            // return data 
            return data;
        }
    }

    public async GetEmailFolders() {

        let body = {};
        body['GetEmailFoldersParam'] = {

        };

        return await this.CallApi(body);
    }

    public async AddEmailDirectory(emailId: number, recordIds: Array<number>): Promise<void> {
        let body = {};
        body['AddEmailDirectoryParam'] = {
            "EmailId": emailId,
            "RecordIds": recordIds
        };

        return await this.CallApi(body);
    }

    public async RemoveEmailDirectory(emailId: number, recordId: number): Promise<void> {
        let body = {};
        body['RemoveEmailDirectoryParam'] = {
            "EmailId": emailId,
            "RecordId": recordId
        };

        return await this.CallApi(body);
    }

    public async AddEmailRecord(emailId: number, recordName: string, recordIds: Array<number>, addType: string): Promise<void> {
        let body = {};
        body['AddEmailRecordParam'] = {
            "EmailId": emailId,
            "RecordName": recordName,
            "RecordIds": recordIds,
            "AddType": addType
        };

        return await this.CallApi(body);
    }

    public async RemoveEmailRecord(emailId: number, recordName: string, recordId: number): Promise<void> {
        let body = {};
        body['RemoveEmailRecordParam'] = {
            "EmailId": emailId,
            "RecordName": recordName,
            "RecordId": recordId
        };

        return await this.CallApi(body);
    }

}
